<span class="cart-confirmation-agreement__agreement-checkbox" color="primary">
  {{ 'cart-confirmation.terms-and-conditions-prefix' | translate }}
  <a (click)="redirectToTermsAndConditions($event)" class="cart-confirmation-agreement__conditions-link">
    {{ 'cart-confirmation.terms-and-conditions' | translate }}
  </a>
  {{ 'cart-confirmation.terms-and-conditions-postfix' | translate }}
</span>
